import Helper from "@ember/component/helper";
import { service } from "@ember/service";
import type IntlService from "ember-intl/services/intl";
import type JournalEventModel from "parog-web/models/journal-event";
import Medic from "parog-web/models/medic";
import Patient from "parog-web/models/patient";

export function compute([je]: [JournalEventModel], intl) {
  if (je.creator instanceof Patient) return "déclaration Patient";
  if (je.creator instanceof Medic) {
    const name =
      je.creator.role == "doctor" ? je.creator.lastName : je.creator.fullName;

    return intl.t(`creator.medic.${je.creator.role}`, {
      name
    });
  }

  // If not imported from HPRIM, or declared by a patient or a medic
  // let's display a generic message
  return "par le programme";
}

export default class JeSourceHelper extends Helper {
  @service declare intl: IntlService;

  compute([je]: [JournalEventModel]) {
    return compute([je], this.intl);
  }
}
